const zIndex = {
	cookiesBar: 1,
	searchModal: 9,
	loading: 9,
	pageOverlay: 9,
	header: 11,
	headerLogo: 11,
	mobileToolbar: 10,
	modals: 999999,
	entryMask: 100,
	mobileNav: 101,
};

export default zIndex;
